function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Account Logout"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-width": 32,
  "data-height": 31,
  className: "iconic-container iconic-account-logout",
  transform: "scale(1 1 ) translate(0 ) "
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  className: "iconic-account-logout-entrance iconic-property-accent iconic-property-stroke",
  d: "M12.5 1.5h18v28h-18",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 3,
  strokeLinecap: "square",
  strokeMiterlimit: 10,
  className: "iconic-account-logout-arrow iconic-account-logout-arrow-line iconic-property-stroke",
  d: "M19.5 15.5h-14.5",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.4 15.2l5.2-3.9c.2-.2.4-.1.4.2v8c0 .3-.2.4-.4.2l-5.2-3.9c-.2-.2-.2-.4 0-.6z",
  className: "iconic-account-logout-arrow iconic-account-logout-arrow-head iconic-property-fill"
}));

function SvgAccountLogoutMd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-icon": "account-logout",
    width: 32,
    height: 32,
    className: "iconic iconic-account iconic-size-md iconic-account-logout",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLogoutMd);
export default __webpack_public_path__ + "static/media/account-logout-md.ca3df2de.svg";
export { ForwardRef as ReactComponent };